import { useDispatch, useSelector } from 'react-redux'

import { createOrder } from '../store/checkoutActions'
import {
  addToCart,
  cartTotalSelector,
  clearError,
  removeFromCart,
  reset,
  setCurrentStep,
  setPaymentError,
  setPaymentMethod,
  updateCartItem
} from '../store/checkoutSlice'

const useCheckout = () => {
  const state = useSelector(state => state.checkout)
  const dispatch = useDispatch()

  return {
    ...state,
    cartTotal: cartTotalSelector(state),
    setCurrentStep: payload => dispatch(setCurrentStep(payload)),
    reset: payload => dispatch(reset(payload)),
    clearError: payload => dispatch(clearError(payload)),
    setPaymentMethod: payload => dispatch(setPaymentMethod(payload)),
    setPaymentError: payload => dispatch(setPaymentError(payload)),
    addToCart: payload => dispatch(addToCart(payload)),
    updateCartItem: payload => dispatch(updateCartItem(payload)),
    removeFromCart: payload => dispatch(removeFromCart(payload)),
    createOrder: payload => dispatch(createOrder(payload))
  }
}

export default useCheckout
